import React from 'react'

import {
  classnames,
  Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  object,
  string,
  number,
  func,
} from 'prop-types'

import useApiPost from 'Pods/Shared/Hooks/useApiPost'

import { NOOP } from 'Utils/stableDefaults'
import updatePageConfigCartData from 'Utils/UpdatePageConfigCart'

import AddIcon from './Components/AddIcon/AddIcon'
import RemoveIcon from './Components/RemoveIcon/RemoveIcon'

function Action({
  data,
  actionType,
  listType = '',
  itemIndex,
  trackCartRemoveGA4 = NOOP,
  trackAddToCart = NOOP,
}) {
  const { postData, isLoading } = useApiPost()
  const { attributes: { id: itemId } } = data

  function removeCartItem() {
    trackCartRemoveGA4(Number(data.id))
    /* eslint-disable-next-line no-undef */
    App.events.publish('app:cart:item:remove', data)
    App.events.publish('item-removed-from-cart')
    window.dispatchEvent(new Event('item-removed-from-cart'))
  }

  function addItemToCart() {
    const payload = {
      index: itemIndex,
      item_list_id: listType,
    }

    postData({
      path: `/api/internal/cg/items/${itemId}/cart_items`,
      payload,
      onSuccess: (response) => {
        const { data: { meta: cartData } } = response
        trackAddToCart(itemId, itemIndex)

        // refresh cart widget in navigation.
        App.events.publish('app:cart:refresh')

        // update cart items in page-config.
        updatePageConfigCartData(cartData, itemId)
      },
      onError: (err) => {
        if (window.showNotification) { // fast page notification
          window.showNotification(err.response.data.errors.detail, {
            type: 'error',
            autohide: true,
          })
        } else { // slow page notification
          App.events.publish('app:notification:flash:error', err.response.data.errors.detail)
        }
      },
    })
  }

  if (actionType === 'add') {
    return (
      <div className="product-list__item-action">
        <div
          className={classnames(
            'product-list__item-action-button',
            isLoading && 'product-list__item-action-button--disabled'
          )}
          data-tip
          data-for="addToCart"
          onClick={addItemToCart}
        >
          <Icon
            color="primary"
            notSpaced
            size="small"
            svgComponent={AddIcon}
            className="remove-icon"
            disabled={isLoading}
          />
        </div>
      </div>
    )
  }

  return (
    <div className="product-list__item-action">
      <div
        className="product-list__item-action-button"
        data-tip
        data-for="removeFromCart"
        onClick={removeCartItem}
      >
        <Icon
          color="dark"
          notSpaced
          size="small"
          svgComponent={RemoveIcon}
          className="remove-icon"
        />
      </div>
    </div>
  )
}

Action.propTypes = {
  data: object.isRequired,
  actionType: string.isRequired,
  listType: string,
  itemIndex: number.isRequired,
  trackCartRemoveGA4: func,
  trackAddToCart: func,
}

export default Action
